// extracted by mini-css-extract-plugin
export var container = "countdown-module--container--30692";
export var countdown = "countdown-module--countdown--6d435";
export var countdownWrapper = "countdown-module--countdown-wrapper--90e24";
export var danger = "countdown-module--danger--cca1b";
export var preAccessMessage = "countdown-module--pre-access-message--709e4";